<template>
  <div class="md:shadow-xl leading-6 bg-white shadow-lg">
    <FixedAspect :ratio="0.56">
      <CldnImg
        v-if="imageSrc"
        :src="imageSrc"
        :alt="entry.image[0].title"
        sizes="75vw sm:20vw md:30vw lg:30vw xl:30vw 2xl:30vw"
        crop="fill"
      />
    </FixedAspect>
    <div class="flex flex-col items-center p-4">
      <h5 v-if="title" class="my-2 text-center">{{ title }}</h5>
      <!-- <div class="tile-description" /> -->
      <div
        v-if="description"
        class="line-clamp-3 my-2 text-center"
        :class="{ 'h-[4.5rem]': isInSlider }"
        v-html="description"
      ></div>
      <ProductComparePrice
        v-if="price"
        :price="price.price"
        :compare-at-price="price.compareAtPrice"
        compare-price-class="fluid-sm tracking-wider font-medium"
        class="fluid-lg leading-tight font-medium sm:h-4 lg:h-5 xl:h-6 relative h-4 my-2"
      />
      <LinkField v-if="cta" v-bind="cta" class="border-blackly sm:leading-6 my-2 leading-4">
        {{ cta.text || $t('explore') }}
      </LinkField>
    </div>
  </div>
</template>

<script>
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';
import ProductComparePrice from '@/components/common/ProductComparePrice';
import LinkField from '@/components/common/LinkField';

export default defineNuxtComponent({
  name: 'EducationTile',
  components: { ProductComparePrice, CldnImg, FixedAspect, LinkField },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    isInSlider: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    description() {
      return this.entry?.description;
    },
    imageSrc() {
      return this.entry?.image[0]?.url;
    },
    title() {
      return this.entry?.academyPage[0]?.title;
    },
    price() {
      const page = this.entry?.academyPage.length && this.entry?.academyPage[0];
      return page ? { price: { amount: page.price }, compareAtPrice: { amount: page.compareAtPrice } } : null;
    },
    cta() {
      return this.entry?.cta;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.tile-cta {
  @apply fluid-sm tracking-wider font-medium whitespace-nowrap inline-flex justify-center px-6 py-2.5 text-center transition-all duration-150 transform border rounded-full lg:px-10 lg:py-3 max-w-[175px];
}
.tile-cta:focus {
  @apply outline-hidden;
}

.tile-cta:active {
  @apply scale-95;
}
</style>
